/* global axios */
import ApiClient from './ApiClient';

class ConversationProductsAPI extends ApiClient {
  constructor() {
    super('conversations', {
      accountScoped: true,
    });
  }

  getUrl(conversationId) {
    return `${this.url}/${conversationId}/products`;
  }

  get(conversationId) {
    return axios.get(this.getUrl(conversationId));
  }

  show(conversationId, productId) {
    return axios.get(`${this.getUrl(conversationId)}/${productId}`);
  }

  create(conversationId, productData) {
    return axios.post(this.getUrl(conversationId), {
      product: productData,
    });
  }

  update(conversationId, productId, productData) {
    return axios.patch(`${this.getUrl(conversationId)}/${productId}`, {
      product: productData,
    });
  }

  delete(conversationId, productId) {
    return axios.delete(`${this.getUrl(conversationId)}/${productId}`);
  }
}

export default new ConversationProductsAPI();
